// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_imageStyle__HcNQY{
    width:31px !important;
    height:31px !important;
    object-fit: cover;
    border-radius:5px;
    margin-bottom:5px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/OnlineChat/RepliedMessage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":[".imageStyle{\n    width:31px !important;\n    height:31px !important;\n    object-fit: cover;\n    border-radius:5px;\n    margin-bottom:5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageStyle": `styles_imageStyle__HcNQY`
};
export default ___CSS_LOADER_EXPORT___;
